import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne, RelationId} from "typeorm";
import {BaseEntity} from "./BaseEntity";
import {MaxLength} from "class-validator";
import {Region} from "@/modules/base/entity/Region";
import {CountryEnum} from "@/modules/base/enums";

@Entity()
export class Country extends BaseEntity {
  @Column({type: 'varchar', length: '50'})
  @MaxLength(50)
  name: CountryEnum;

  @ManyToOne(() => Region, region => region.countries)
  region: Relation<Region>;

  @RelationId((m: Country) => m.region)
  regionId: number;

  @Column({type: 'integer'})
  population = 0;

  @Column({type: 'integer'})
  level = 1;
}
